import gql from 'graphql-tag';

export default gql`
  query users {
    users {
      id
      name
      email
      status
      permissions {
        action
      }
      userGroups {
        groupId
        name
        permissions {
          action
        }
      }
    }
  }
`;
